<template>
  <div class="checkbox-wrapper">
    <div class="checkbox-inner">
      <label class="checkbox">
        <input
          type="checkbox"
          class="checkbox__input"
          tabindex="0"
          @keydown.space="onClick"
        >
        <div
          class="checkbox__custom"
          :class="[{ 'active': checked && isVariant === 2, 'disabledColor': validate }]"
          @click="onClick"
        >
          <transition name="drop">
            <Checkmark
              v-if="checked && isVariant === 1"
              class="checkbox__custom-checkmark"
            />
            <Checkmark2
              v-if="checked && isVariant === 2"
              class="checkbox__custom-checkmark"
            />
            <Checkmark2
              v-if="checked && isVariant === 2"
              class="checkbox__custom-checkmark"
            />
            <Checkmark3
              v-if="checked && isVariant === 3"
              class="checkbox__custom-checkmark variant3"
            />
          </transition>
        </div>
      </label>

      <div class="checkbox__text">
        <slot />
      </div>
    </div>

    <transition name="slide-from-top">
      <span
        v-if="error && errorMsg"
        class="checkbox__error-msg"
      >
        {{ errorMsg }}
      </span>
    </transition>
  </div>
</template>

<script>
  import Checkmark from '@/assets/img/icons/checkmark.svg?inline'
  import Checkmark2 from '@/assets/img/icons/checkmark2.svg?inline'
  import Checkmark3 from '@/assets/img/icons/checkmark3.svg?inline'

  export default {
    name: 'BaseCheckbox',
    components: {
      Checkmark,
      Checkmark2,
      Checkmark3
    },
    props: {
      customHandler: {
        type: Function
      },
      validate: {
        type: Boolean,
        default: false
      },
      isVariant: {
        type: Number,
        default: 1
      },
      value: {
        type: Boolean,
        default: false
      },
      errorMsg: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        checked: this.value,
        error: null
      }
    },
    watch: {
      value: {
        handler (v) {
          this.checked = v
        },
        immediate: true
      },
      errorMsg: {
        handler (msg) {
          this.error = !!msg
        },
        immediate: true
      }
    },
    methods: {
      onClick () {
        if (!this.validate || this.checked) {
          this.error = false
          this.checked = !this.checked
          this.$emit('input', this.checked)
        } else if (this.customHandler) {
          this.customHandler()
        }
      }
    }
  }
</script>

<style lang="scss">
  $padding-for-error: 28px;

  .checkbox {
    display: inline-block;
    flex-shrink: 0;
    width: 18px;
    height: 18px;

    &-inner {
      display: flex;
      align-items: center;
    }

    &-wrapper {
      position: relative;
      padding-bottom: $padding-for-error;
    }

    &__custom {
      width: 100%;
      height: 100%;
      cursor: pointer;
      border: 2px solid $c-gray-light;
      border-radius: 4px;
      transition: 0.3s;

      @include hover {
        border-color: $c-gray-medium;
      }

      &.active {
        border-color: $c-black !important;
        background-color: $c-black;
      }

      &-checkmark {
        width: 9px;
        height: 9px;
        margin-bottom: 2px;
        margin-left: 2px;
        fill: $c-active-light;

        &.variant3 {
          width: 14px;
          height: 12px;
          margin-bottom: 2px;
          margin-left: 4px;
          fill: none;

          @include mobile {
            margin-bottom: -2px;
            margin-left: 4px;
          }
        }
      }
    }

    &__input {
      position: absolute;
      left: -9999999px;
      width: 0;
      height: 0;
      opacity: 0;

      &:focus {
        & + .checkbox__custom {
          border-color: $c-gray-medium;
        }
      }
    }

    &__text {
      margin-left: 8px;
      font-family: "ToyotaType-Book", Arial, Helvetica, sans-serif;

      a {
        font-size: 16px;
      }
    }

    &__error-msg {
      position: absolute;
      top: 77%;
      left: 0;
      font-size: 12px;
      color: $c-active-light;
    }
  }
</style>
